/*
 * TPS perks (main-product blogu tps_perks): kargo gunu satiri + sepetle senkron avantaj merdiveni.
 * - Kargo: tps-perks.liquid ile ayni kural; magaza saati = UTC + data-offset (Liquid %z, or. +0300).
 * - Merdiven: ilk cizim Liquid'den gelir; bu dosya /cart.js ile senkron tutar.
 *   Tetikleyiciler: PUB_SUB cartUpdate, cart:updated (tam sepet varsa dogrudan), ajaxProduct:added, cart:refresh,
 *   sayfadaki her /cart/add|change|update|clear istegi (PerformanceObserver: tema disi app'ler dahil),
 *   sekmeye donus (visibilitychange) ve geri/ileri onbellegi (pageshow). Istekler birlestirilir; eski yanit yok sayilir.
 * - Tutar bicimi tps-perks-money.liquid ile birebir ('tr' | 'store').
 * Tema bagimliliklari (pubsub.js, global.js theme.Currency) yoksa guvenli yedekle calisir.
 */
(() => {
  if (customElements.get('tps-perks')) return;

  const MUTATION = /\/cart\/(add|change|update|clear)(\.js)?$/;

  /* Paylasilan sepet deposu: sayfada kac blok olursa olsun tek istek. */
  const store = {
    cart: null,
    url: '/cart',
    listeners: new Set(),
    seq: 0,
    timer: 0,
    ctrl: null,
    ready: false,

    subscribe(fn) {
      this.listeners.add(fn);
      this.init();
      return () => this.listeners.delete(fn);
    },

    set(cart) {
      if (!cart || typeof cart.items_subtotal_price !== 'number' || !Array.isArray(cart.items)) return false;
      this.seq++; // bekleyen eski yanit bunu ezmesin
      this.cart = cart;
      this.listeners.forEach((fn) => fn(cart));
      return true;
    },

    refresh(delay = 120) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.load(), delay);
    },

    load() {
      if (!this.listeners.size) return;
      const id = ++this.seq;
      if (this.ctrl) this.ctrl.abort();
      const ctrl = (this.ctrl = typeof AbortController === 'function' ? new AbortController() : null);
      fetch(`${this.url}.js`, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' },
        signal: ctrl ? ctrl.signal : undefined,
      })
        .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
        .then((cart) => {
          if (id === this.seq) this.set(cart);
        })
        .catch(() => {});
    },

    init() {
      if (this.ready) return;
      this.ready = true;
      const later = () => this.refresh();

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, later);
      }
      document.addEventListener('cart:updated', (e) => {
        if (!this.set(e.detail && e.detail.cart)) later();
      });
      ['ajaxProduct:added', 'cart:refresh'].forEach((name) => document.addEventListener(name, later));

      try {
        new PerformanceObserver((list) => {
          for (const entry of list.getEntries()) {
            if (entry.initiatorType !== 'fetch' && entry.initiatorType !== 'xmlhttprequest') continue;
            let path = '';
            try {
              path = new URL(entry.name, location.href).pathname;
            } catch (_) {}
            if (MUTATION.test(path)) {
              later();
              break;
            }
          }
        }).observe({ type: 'resource' });
      } catch (_) {
        /* eski tarayici: tema olaylari yeterli */
      }

      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') this.refresh(0);
      });
      window.addEventListener('pageshow', (e) => {
        if (e.persisted) this.refresh(0);
      });
    },
  };

  const esc = (s) =>
    String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const fill = (str, map) => Object.keys(map).reduce((out, key) => out.split(key).join(map[key]), str);

  customElements.define(
    'tps-perks',
    class extends HTMLElement {
      connectedCallback() {
        this.updateShip();

        const cfgEl = this.querySelector('script[data-config]');
        if (!cfgEl) return;
        try {
          this.cfg = JSON.parse(cfgEl.textContent);
        } catch (_) {
          return;
        }
        const c = this.cfg;
        this.trackEl = this.querySelector('[data-track]');
        this.fillEl = this.querySelector('[data-fill]');
        this.msgEl = this.querySelector('[data-msg]');
        this.stopEls = Array.from(this.querySelectorAll('[data-stop]'));
        this.base = Number(c.base) || 0;
        this.variantId = c.variantId;
        this.variantPrice = Number(c.variantPrice) || 0;
        this.inCart = !!c.inCart;
        this.cartItems = null;
        this.qty = this.readQty();
        this.cleanups = [];

        if (c.includeSelection) this.bindSelection();

        if (c.previewCents >= 0) {
          /* editor onizleme tutari: sepete baglanmaz */
          this.render();
          return;
        }

        store.url = c.cartUrl || store.url;
        this.cleanups.push(store.subscribe((cart) => this.onCart(cart)));
        if (store.cart) this.onCart(store.cart);
        else store.refresh(0); // HTML onbellekten gelmis olabilir: gercek sepeti bir kez al
      }

      disconnectedCallback() {
        (this.cleanups || []).forEach((fn) => fn());
        this.cleanups = [];
      }

      /* ——— kargo satiri ——— */
      updateShip() {
        const d = this.dataset;
        const el = this.querySelector('[data-ship]');
        const o = /^([+-])(\d\d)(\d\d)$/.exec(d.offset || '');
        if (!el || !o) return;
        const t = new Date(Date.now() + (o[1] === '-' ? -1 : 1) * (o[2] * 60 + +o[3]) * 6e4);
        const w = t.getUTCDay();
        const h = t.getUTCHours();
        const names = (d.days || '').split(',');
        for (let i = 0; i < 8; i++) {
          const k = (w + i) % 7;
          if ((k === 6 && d.sat !== 'true') || (k === 0 && d.sun !== 'true') || (!i && h >= +d.cutoff)) continue;
          const text = !i ? d.today : i === 1 ? d.tomorrow : (d.next || '').split('[day]').join(names[k] || '');
          if (text && el.textContent !== text) el.textContent = text;
          return;
        }
      }

      /* ——— secili urun onizlemesi ——— */
      bindSelection() {
        const sid = this.cfg.sectionId;
        const onVariant = (variant) => {
          this.variantId = variant ? variant.id : null;
          this.variantPrice = variant && variant.available ? Number(variant.price) || 0 : 0;
          this.syncInCart();
          this.render();
        };
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.cleanups.push(
            subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
              if (e && e.data && e.data.sectionId === sid) onVariant(e.data.variant);
            })
          );
        }
        const onQty = (e) => {
          if (!e.target || e.target.id !== `Quantity-${sid}`) return;
          const q = this.readQty();
          if (q !== this.qty) {
            this.qty = q;
            this.render();
          }
        };
        document.addEventListener('change', onQty);
        document.addEventListener('input', onQty);
        this.cleanups.push(() => {
          document.removeEventListener('change', onQty);
          document.removeEventListener('input', onQty);
        });
      }

      readQty() {
        const input = document.getElementById(`Quantity-${this.cfg.sectionId}`);
        const q = input ? parseInt(input.value, 10) : 1;
        return q > 0 ? q : 1;
      }

      syncInCart() {
        if (this.cartItems) this.inCart = this.cartItems.some((item) => item.variant_id === this.variantId);
      }

      onCart(cart) {
        // Liquid ile aynı esas: subtotal = items_subtotal_price (satır indirimleri sonrası), original = liste toplamı, total = sepet indirimi sonrası.
        this.base = this.cfg.basis === 'total' ? cart.total_price
          : this.cfg.basis === 'original' ? cart.original_total_price
          : cart.items_subtotal_price;
        this.cartItems = cart.items;
        this.syncInCart();
        this.render();
      }

      /* ——— hesap + cizim ——— */
      rate() {
        const cur = window.Shopify && window.Shopify.currency;
        const r = cur ? parseFloat(cur.rate) : 1;
        return cur && cur.active && this.cfg.shopCurrency && cur.active !== this.cfg.shopCurrency && r > 0 ? r : 1;
      }

      money(cents) {
        const c = Math.round(Math.abs(cents));
        const fmt = this.cfg.moneyFormat;
        if (this.cfg.style === 'store' && fmt && window.theme && theme.Currency && theme.Currency.formatMoney) {
          return theme.Currency.formatMoney(c, fmt).replace(/([.,])00(?!\d)/, '');
        }
        const major = String(Math.floor(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        const minor = c % 100;
        return major + (minor ? `,${String(minor).padStart(2, '0')}` : '') + (this.cfg.symbol || '');
      }

      render() {
        const c = this.cfg;
        const rate = this.rate();
        const tiers = c.tiers.map((t) => ({ ...t, at: Math.round(t.cents * rate) }));
        const n = tiers.length;
        if (!n) return;
        const sel = c.includeSelection && !this.inCart ? this.variantPrice * this.qty : 0;
        const total = this.base + sel;

        let width = 100;
        let next = -1;
        let prevAt = 0;
        let prevPos = 0;
        tiers.forEach((t, i) => {
          const pos = ((2 * i + 1) * 50) / n;
          if (next < 0 && total < t.at) {
            next = i;
            const span = t.at - prevAt;
            width = span > 0 ? prevPos + ((pos - prevPos) * (total - prevAt)) / span : pos;
          }
          prevAt = t.at;
          prevPos = pos;
        });
        width = Math.max(0, Math.min(100, width));

        this.stopEls.forEach((el, i) => {
          const reached = !!tiers[i] && total >= tiers[i].at;
          el.classList.toggle('is-reached', reached);
          const label = el.querySelector('[data-reached]');
          if (label) label.hidden = !reached;
        });
        if (this.fillEl) this.fillEl.style.width = `${Math.round(width * 100) / 100}%`;

        let html = '';
        if (next >= 0) {
          const t = tiers[next];
          html = fill(esc(t.message), {
            '[remaining]': `<strong class="tps-perks__em">${esc(this.money(t.at - total))}</strong>`,
            '[amount]': esc(this.money(t.at)),
            '[benefit]': esc(t.benefit),
          });
        } else {
          html = esc(c.complete);
        }

        if (this.msgEl) {
          /* yalniz metin degisirse yaz: aria-live gereksiz duyuru yapmasin */
          const probe = document.createElement('template');
          probe.innerHTML = html;
          if (probe.innerHTML !== this.msgEl.innerHTML) this.msgEl.innerHTML = probe.innerHTML;
          this.msgEl.hidden = !html;
        }
        if (this.trackEl) {
          const last = tiers[n - 1].at;
          this.trackEl.setAttribute('aria-valuemax', String(Math.floor(last / 100)));
          this.trackEl.setAttribute('aria-valuenow', String(Math.floor(Math.min(total, last) / 100)));
          this.trackEl.setAttribute('aria-valuetext', this.msgEl ? this.msgEl.textContent.trim() : '');
        }
      }
    }
  );
})();
